import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuList } from '../navigation-drawer-case1/navigation-drawer.constant';

@Component({
  selector: 'app-sample-module-for-navigation-drawer',
  templateUrl: './sample-module-for-navigation-drawer.component.html'
})
export class SampleModuleForNavigationDrawerComponent implements OnInit {
  cascadeMenus: any = [];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  toolbarHamburgerAriaLabel: string = 'Menu';
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];
  constructor(private activRoute: ActivatedRoute) {

  }
  getMenuItem(navItems: any, hierarchyLevel: any) {
    let item: any = {};
    if (navItems[hierarchyLevel[1]] && navItems[hierarchyLevel[0]]?.children && hierarchyLevel.length > 2) {
      let childItems = navItems[hierarchyLevel[0]].children;
      hierarchyLevel.splice(0, 1);
      item = this.getMenuItem(childItems, hierarchyLevel);
    } else {
      item = navItems[hierarchyLevel[0]];
    }
    return item;
  }
  ngOnInit(): void {
    this.activRoute.queryParams.subscribe((param: any) => {
      let hierarchyLevel = this.activRoute.snapshot.queryParams?.menuHierarchy?.split('_') || [];
      if (hierarchyLevel.length > 1) {
        let item = this.getMenuItem(MenuList, hierarchyLevel);
        if (item) {
          item.children?.forEach((val: any) => {
            if (val.url?.includes(this.activRoute.snapshot.url[0].path)) {
              val.active = true;
            } else {
              val.active = false;
            }
            val.selected = false;
          })
          this.cascadeMenus.push({
            name: 'Menu',
            isVisible: true,
            menus: item.children
          });
        }
      }
    })
  }
}
